import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { feedScan, useAccountID } from "../../store/account";

export default function FeedScan() {
    const [submitting, setSubmitting] = useState(false);
    const accountID = useAccountID();
    const dispatch = useDispatch();
    const onClick = async () => {
        setSubmitting(true);
        await dispatch(feedScan(accountID));
        setSubmitting(false);
    };

    return (
        <>
            <Helmet>
                <title>Rescan Feeds - Podtrac</title>
            </Helmet>
            <h1>Rescan Feeds</h1>
            <p>
                We scan your feed on a schedule based the recent publication times for your show. If
                newly published episodes aren't visible on your Dashboard, click the button below to
                schedule a rescan of your feed.
            </p>
            <button disabled={submitting} onClick={onClick}>
                Schedule Feed Scan
            </button>
        </>
    );
}
